<style>
#valvesStateLegend .v--modal-box.v--modal {
  min-height: 400px !important;
  min-width: 270px !important;
}
#valvesStateLegend .v-list__tile {
    height: 44px !important;
}
#valvesStateLegend .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="valvesStateLegend"
    title="Legenda analizy zasuw"
    :buttons="['']"
  >
    <div id="wrapper">
      <v-flex xs12 >
        <v-list>
          <v-list-tile
            v-for="(value, key) in states"
            :key="key"
            avatar
          >
            <v-list-tile-avatar>
              <img :src="value"/>
            </v-list-tile-avatar>
            
            <v-list-tile-content>
              <v-list-tile-title v-text="key"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        
        <v-checkbox
            label="Pokazuj nadal legende"
            v-model="valvesStateLegend"
          ></v-checkbox>
      </v-flex>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

const assets = '../../../../assets';

const states = {
  "Inny" : require(`../../../../assets/map_icons/valves_else.svg`),
  "Brak danych" : require(`../../../../assets/map_icons/valves_else.svg`),
  "Otwarty" : require(`../../../../assets/map_icons/valves_open_work.svg`),
  "Zamknięty" : require(`../../../../assets/map_icons/valves_close_work.svg`),
  "Uszkodzony otwarty" : require(`../../../../assets/map_icons/valves_open_not_work.svg`),
  "Uszkodzony zamknięty" : require(`../../../../assets/map_icons/valves_close_not_work.svg`),
};

export default {
  components: {
    Modal
  },
  data: () => ({
    valvesStateLegend : true,
    states
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  watch: {
    valvesStateLegend(_new) {
      this.$store.commit('setValvesStateLegend', _new);
    }
  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/ValvesStateLegend.vue